/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Popover } from '@material-ui/core';
import React, { useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { Divider } from '@material-ui/core';
import { Dropdown } from 'react-bootstrap';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import { setViewCheckAllocationDetails,setViewCheckAllocationTab } from '../../ViewCheckAllocation/store/actions';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ExportIcon from '../../../../assets/images/Icon-Component-Export.svg';
export const ActionCellRenderer = (cellInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
    const [anchor, setAnchor] = useState(null);
    const viewCheckAllocationTab = useSelector(
        (state) => state.sharedState.ViewCheckAllocation?.viewCheckAllocationObj
      );
    const open = Boolean(anchor);
    const handleClose = () => {
      setAnchor(null);
    };
  const handleAction = () => {
    dispatch(setViewCheckAllocationDetails(cellInfo.data));
    dispatch(setViewCheckAllocationTab({...viewCheckAllocationTab,index:0}));
    redirectURLLink(
      '/checkAllocDetail',
      'Check Alloc Detail',
      history,
      dispatch
    );
  };
  return (
  <div
        className="tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center"
        style={{ top: 0 }}
      >
        <div
          style={{ height: 'max-content' }}
          onClick={(e) => {
            setAnchor(e.currentTarget);
          }}
        >
          <SVGComponent iconName="Export-icon" />
        </div>
        <Popover
          open={open}
         anchorEl={anchor}
          onClose={handleClose}
          disableScrollLock={true}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <div className="d-flex flex-column py-2">
            <span
              className="dropdown-item"
              onClick={() => {
                handleAction();
              }}
            >
              Go to Check Allocation
            </span>
         
          </div>
        </Popover>
      
      </div>
    
  );
};

export const DateRenderer = (cellInfo) => {
  if (cellInfo?.value && cellInfo?.value !== null && cellInfo?.value !== '') {
    return <div>{moment(cellInfo?.value).format('MM/DD/YYYY')}</div>;
  }
  return null;
};

export const CheckCellRender = (cellInfo) => {
  const name = cellInfo?.value;
  let boolRed = false;

  if (cellInfo?.data?.checkAmt || cellInfo?.data?.totAllocatedAmt) {
    const nameAmt = name?.toString().replace('$', '').trim();

    if (nameAmt < 0) {
      boolRed = true;
    } else if (nameAmt > 0) {
      boolRed = false;
    }
  }

  if (name && name.length > 20) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
      >
        {boolRed ? (
          <div style={{ color: 'red' }}>
            {name &&
              (`(${name.substring(0, 20)}...` + ')').replace('-', '').trim()}
          </div>
        ) : (
          <div>{name && `${name.substring(0, 20)}...`}</div>
        )}
      </OverlayTrigger>
    );
  }
  return (
    <div>
      {boolRed ? (
        <div style={{ color: 'red' }}>
          {`(${name})`.replace('-', '').trim()}
        </div>
      ) : (
        <div>{name}</div>
      )}
    </div>
  );
};
